module.exports = __webpack_public_path__ + "img/tips-top.328db60a.gif";